// INSTALLATION LOCATION
export const GET_INSTALLATION_LOCATIONS = '/installation_location/query';
export const GET_INSTALLATION_LOCATION = '/installation_location/';
export const POST_INSTALLATION_LOCATION = '/installation_location/';
export const PUT_INSTALLATION_LOCATION = '/installation_location/';
export const DELETE_INSTALLATION_LOCATION = '/installation_location/';
export const CHECK_INSTALLATION_LOCATION_EXISTS = '/installation_location/query';
